<template>
	<div class="space-y-xs">
		<div class="h-[2px] rounded-full bg-gray-300">
			<div
				class="h-[2px] rounded-full bg-black"
				:style="{
					width: `${(current / total) * 100}%`,
				}"
			></div>
		</div>

		<p class="text-center">
			<slot />
		</p>
	</div>
</template>

<script lang="ts" setup>
defineProps<{
	total: number;
	current: number;
}>();
</script>
